module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sS1VRI/tc-custom/9781631941993.jpg?1705201909919",
      "alt": "This image is the cover for the book Haunted Martyr, Denton"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunted Martyr, Denton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The expat author travels to Italy, where communing with the dead can lead to murder, in this historical mystery by the author of "), _c('i', [_vm._v("The Second Woman")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" England in the chilly winter of 1902 is captive to a new craze: Mediums and psychics are springing up like toadstools after a rainstorm, and the public is rushing to consult them, thirsty for intimations of the Great Beyond. It’s no surprise that a man like Denton has his doubts: An American Yankee in King Edward's city, he is a walking representative of the “Show Me” state."), _c('br'), _c('br'), _vm._v(" Nevertheless, Denton agreed to write a book about ghosts and hauntings, and has taken himself to Italy to do it. Napoli may be "), _c('i', [_vm._v("bella")]), _vm._v(", but it offers Denton only boredom and frustration, until a dead body shows up to make life interesting. As he tries to divine the killer’s identity, the cold hard clues give him a new angle on his new spiritualist friends.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kenneth Cameron\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kenneth Cameron, AKA George Bartram, was born June 26, 1931, in Rochester, NY. He is the author of three previous novels featuring Denton, an American with a violent past: THE FRIGHTENED MAN, THE BOHEMIAN GIRL, and THE SECOND WOMAN. Cameron is also the author or co-author of more than thirty books, including historical fiction and espionage, a critical history of the African safari, and an award-winning analysis of films about Africa.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0